import {
  getHierarchyTotalScreens,
  type VenueHierarchy,
} from '@/features/billboards/types/hierarchy';

export type { VenueHierarchy } from '@/features/billboards/types/hierarchy';

export type DiscoveryFilters = {
  locationType: string;
  venueType: string;
  VenueSubType: string;
};

export const LOCATION_TYPE_ICONS: Record<string, string> = {
  indoor: '🏢',
  outdoor: '🌆',
  'transit-media': '🚌',
  INDOOR: '🏢',
  OUTDOOR: '🌆',
  VEHICLE: '🚌',
  TRANSIT: '🚉',
  'TRANSIT MEDIA': '🚉',
};

export const DEFAULT_CITY = 'Bhopal';

export function formatMetric(value?: number | null): string | number {
  if (value == null) return '0';
  if (typeof value === 'number' && value % 1 !== 0) return value.toFixed(1);
  return value;
}

export function resolveTotalScreens(hierarchy?: VenueHierarchy) {
  return getHierarchyTotalScreens(hierarchy);
}
